import '@tao/plattform/src/js/index.js';

// Load Module.
import Hotspot from './hotspot-tao.js';

// Initialise Modules.
Hotspot.init();

// Require bootstrap
require( 'bootstrap' );

// Inclue TAO Modules
require( './hashjump-tao' );
require( './accordion-tao' );
